let globalState = {
  isBlockedForRegistration: false,
  lastAction: null
};

const stateListeners = [];

export const stateManager = {
  getState() {
    return { ...globalState };
  },

  setState(newState) {
    const oldState = globalState;
    globalState = { ...globalState, ...newState };

    // Уведомляем всех слушателей об изменении
    stateListeners.forEach(listener => {
      try {
        listener(globalState, oldState);
      } catch (error) {
        console.error('Error in state listener:', error);
      }
    });
  },

  subscribe(listener) {
    stateListeners.push(listener);

    // Возвращаем функцию для отписки
    return () => {
      const index = stateListeners.indexOf(listener);
      if (index > -1) {
        stateListeners.splice(index, 1);
      }
    };
  }
};